// extracted by mini-css-extract-plugin
export default {"msgM":"_4ea3ee97fb"};